import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getMaps } from '../services/requests/EstratoFlorestalRequests'

const mixins = {
	data() {
		return {
			buscandoFazenda: false,

			filtroConfig: {
				IntervaloIdadeSlider: [],
				IntervaloDataSlider: [],
				IntervaloAreaSlider: [],
				IntervaloAreaTalhaoSlider: [],
				selectedCodigosPlantios: [],
				selectedEspacamentos: [],
				selectedMaterialGenetico: [],
				selectedAreaPlantio: [],
				selectedIdadePlantio: [],
				selectedDataPlantio: [],
				codigosColados: [],
				codigosColadosTalhao: [],
				selectedCodigosTalhao: [],
				selectedAreaTalhao: [],
				customsPlantio: [],
				customsTalhao: [],
			},

			copiaEcola: false,
			copiaEcolaTalhao: false,
			filtros: [],
			showDropFk: true,
			fazendas: [],

			tabs: 0,
			tabs2: 0,
			tabs3: 0,
		}
	},
	methods: {
		...mapActions('moduleImportShape', ['setAllShapes']),
		...mapMutations('moduleImportShape', [
			'resetState',
			'setGeoJsonFzda',
			'setGeoJsonTlho',
			'setGeoJsonPtio',
			'setFzdaHasFileInDB',
			'setTlhoHasFileInDB',
			'setPtioHasFileInDB',
		]),
		manejaCustomsPlantio(custom) {
			if (this.filtroConfig.customsPlantio.includes(custom)) {
				this.filtroConfig.customsPlantio.splice(this.filtroConfig.customsPlantio.indexOf(custom), 1)
			} else {
				this.filtroConfig.customsPlantio.push(custom)
			}
		},
		manejaCustomsTalhao(custom) {
			if (this.filtroConfig.customsTalhao.includes(custom)) {
				this.filtroConfig.customsTalhao.splice(this.filtroConfig.customsTalhao.indexOf(custom), 1)
			} else {
				this.filtroConfig.customsTalhao.push(custom)
			}
		},
		resetFiltros() {
			this.filtroConfig = {
				IntervaloIdadeSlider: [],
				IntervaloDataSlider: [],
				IntervaloAreaSlider: [],
				IntervaloAreaTalhaoSlider: [],
				selectedCodigosPlantios: [],
				selectedEspacamentos: [],
				selectedMaterialGenetico: [],
				selectedAreaPlantio: [],
				selectedIdadePlantio: [],
				selectedDataPlantio: [],
				codigosColados: [],
				codigosColadosTalhao: [],
				selectedCodigosTalhao: [],
				selectedAreaTalhao: [],
				customsPlantio: [],
				customsTalhao: [],
			}
		},
		handleChangeArea(e) {
			this.filtroConfig.IntervaloAreaSlider = e
		},
		handleChangeAreaTalhao(e) {
			this.filtroConfig.IntervaloAreaTalhaoSlider = e
		},
		handleChangeData(e) {
			this.filtroConfig.IntervaloDataSlider = e
		},

		// setPlantioSelected() {
		//   this.getGeoJsonPtio.features.forEach(
		//     (feature) => (feature.properties.selected = false)
		//   );

		//   this.getGeoJsonPtio.features.forEach((feature) => {
		//     if (
		//       // verifica se todos os filtros não estão vazios
		//       !Object.values(this.filtroConfig).every((s) => !s.length)
		//     ) {
		//       if (
		//         //verifica se código está selecionado no dropdonw
		//         this.isCodigoPlantioSelected(feature) &&
		//         //verifica se código do talhão está selecionado no dropdonw
		//         this.isCodigoTalhaoSelected(feature) &&
		//         //verifica se codigo de plantio está no campo colado
		//         this.isCodigoPlantioColado(feature) &&
		//         //verifica se codigo de plantio está no campo colado
		//         this.isCodigoTalhaoColado(feature) &&
		//         //verifica se espaçamento está selecionado no dropdown
		//         this.isEspacamentoPlantioSelected(feature) &&
		//         //verifica se material genetico está selecionado no dropdown
		//         this.isMaterialGeneticoPlantioSelected(feature) &&
		//         //verifica se area do plantio está selecionada no dropdown
		//         this.isAreaPlantioSelected(feature) &&
		//         //verifica se area do talhão está selecionada no dropdown
		//         this.isAreaTalhaoSelected(feature) &&
		//         //verifica se data de plantio está selecionada no dropdown
		//         this.isDataPlantioSelected(feature) &&
		//         //verifica se area do plantio está entre o intervalo do slider
		//         this.isAreaPlantioInRange(feature) &&
		//         //verifica se area do talhão está entre o intervalo do slider
		//         this.isAreaTalhaoInRange(feature) &&
		//         //verifica se data do plantio está entre o intervalo do slider
		//         this.isDataPlantioInRange(feature) &&
		//         //varifica se alguma custom de plantio foi selecionada
		//         this.isCustomsPlantioSelected(feature) &&
		//         //varifica se alguma custom de talhao foi selecionada
		//         this.isCustomsTalhaoSelected(feature)

		//         //! Trecho comentado por motivos de: filtros redundantes, data e idade
		//         //! consideram a mesma propriedade, idade está sendo apresentada juntamente
		//         //! com data no dropdown
		//         ////verifica se idade do plantio está selecionada no dropdown
		//         //this.isIdadePlantioSelected(feature) &&
		//         ////verifica se a idade do plantio está entre o intervalo do slider
		//         // this.isIdadePlantioInRange(feature)
		//       ) {
		//         if (!feature.properties.blocked) feature.properties.selected = true;
		//       }
		//     }
		//   });
		// },
		setPlantioSelected() {
			this.getGeoJsonPtio.features.forEach((feature) => {
				if (feature.properties.blocked) {
					feature.properties.selected = false
					return
				}
				feature.properties.selected = this.shouldSelectFeature(feature)
			})
		},

		shouldSelectFeature(feature) {
			if (!Object.values(this.filtroConfig).every((s) => !s.length)) {
				return (
					this.isCodigoPlantioSelected(feature) &&
					this.isCodigoTalhaoSelected(feature) &&
					this.isCodigoPlantioColado(feature) &&
					this.isCodigoTalhaoColado(feature) &&
					this.isEspacamentoPlantioSelected(feature) &&
					this.isMaterialGeneticoPlantioSelected(feature) &&
					this.isAreaPlantioSelected(feature) &&
					this.isAreaTalhaoSelected(feature) &&
					this.isDataPlantioSelected(feature) &&
					this.isAreaPlantioInRange(feature) &&
					this.isAreaTalhaoInRange(feature) &&
					this.isDataPlantioInRange(feature) &&
					this.isCustomsPlantioSelected(feature) &&
					this.isCustomsTalhaoSelected(feature)
				)
			}
			return false
		},

		isCodigoPlantioSelected(feature) {
			return (
				!this.filtroConfig.selectedCodigosPlantios.length ||
				(this.filtroConfig.selectedCodigosPlantios.length &&
					this.filtroConfig.selectedCodigosPlantios.indexOf(feature.properties.idPlantio) > -1)
			)
		},
		isCodigoTalhaoSelected(feature) {
			return (
				!this.filtroConfig.selectedCodigosTalhao.length ||
				(this.filtroConfig.selectedCodigosTalhao.length &&
					this.filtroConfig.selectedCodigosTalhao.indexOf(feature.properties.fkTalhao) > -1)
			)
		},

		isEspacamentoPlantioSelected(feature) {
			return (
				!this.filtroConfig.selectedEspacamentos.length ||
				(this.filtroConfig.selectedEspacamentos.length &&
					this.filtroConfig.selectedEspacamentos.indexOf(feature.properties['Espacamento']) > -1)
			)
		},

		isMaterialGeneticoPlantioSelected(feature) {
			return (
				!this.filtroConfig.selectedMaterialGenetico.length ||
				(this.filtroConfig.selectedMaterialGenetico.length &&
					this.filtroConfig.selectedMaterialGenetico.indexOf(
						feature.properties['Material Genetico'],
					) > -1)
			)
		},

		isAreaPlantioSelected(feature) {
			return (
				!this.filtroConfig.selectedAreaPlantio.length ||
				(this.filtroConfig.selectedAreaPlantio.length &&
					this.filtroConfig.selectedAreaPlantio.indexOf(feature.properties['Area']) > -1)
			)
		},

		isAreaTalhaoSelected(feature) {
			return (
				!this.filtroConfig.selectedAreaTalhao.length ||
				(this.filtroConfig.selectedAreaTalhao.length &&
					this.filtroConfig.selectedAreaTalhao.indexOf(feature.properties.areaTalhao) > -1)
			)
		},

		isIdadePlantioSelected(feature) {
			return (
				!this.filtroConfig.selectedIdadePlantio.length ||
				(this.filtroConfig.selectedIdadePlantio.length &&
					this.filtroConfig.selectedIdadePlantio.indexOf(feature.properties['Data de Plantio']) >
						-1)
			)
		},

		isDataPlantioSelected(feature) {
			return (
				!this.filtroConfig.selectedDataPlantio.length ||
				(this.filtroConfig.selectedDataPlantio.length &&
					this.filtroConfig.selectedDataPlantio.indexOf(feature.properties['Data de Plantio']) > -1)
			)
		},

		isAreaPlantioInRange(feature) {
			return (
				!this.filtroConfig.IntervaloAreaSlider.length ||
				(this.filtroConfig.IntervaloAreaSlider.length &&
					feature.properties['Area'] >= this.filtroConfig.IntervaloAreaSlider[0] &&
					feature.properties['Area'] <= this.filtroConfig.IntervaloAreaSlider[1])
			)
		},

		isAreaTalhaoInRange(feature) {
			return (
				!this.filtroConfig.IntervaloAreaTalhaoSlider.length ||
				(this.filtroConfig.IntervaloAreaTalhaoSlider.length &&
					feature.properties.areaTalhao >= this.filtroConfig.IntervaloAreaTalhaoSlider[0] &&
					feature.properties.areaTalhao <= this.filtroConfig.IntervaloAreaTalhaoSlider[1])
			)
		},

		isIdadePlantioInRange(feature) {
			return (
				!this.filtroConfig.IntervaloIdadeSlider.length ||
				(this.filtroConfig.IntervaloIdadeSlider.length &&
					this.filtroConfig.IntervaloIdadeSlider[1] >=
						new Date(feature.properties['Data de Plantio']).getTime() &&
					this.filtroConfig.IntervaloIdadeSlider[0] <=
						new Date(feature.properties['Data de Plantio']).getTime())
			)
		},

		isDataPlantioInRange(feature) {
			return (
				!this.filtroConfig.IntervaloDataSlider.length ||
				(this.filtroConfig.IntervaloDataSlider.length &&
					this.filtroConfig.IntervaloDataSlider[1] >=
						new Date(feature.properties['Data de Plantio']).getTime() &&
					this.filtroConfig.IntervaloDataSlider[0] <=
						new Date(feature.properties['Data de Plantio']).getTime())
			)
		},

		isCodigoPlantioColado(feature) {
			return (
				!this.filtroConfig.codigosColados.length ||
				(this.filtroConfig.codigosColados.length &&
					this.filtroConfig.codigosColados.indexOf(feature.properties['Codigo Plantio']) > -1)
			)
		},
		isCodigoTalhaoColado(feature) {
			return (
				!this.filtroConfig.codigosColadosTalhao.length ||
				(this.filtroConfig.codigosColadosTalhao.length &&
					this.filtroConfig.codigosColadosTalhao.indexOf(feature.properties['Codigo do Talhao']) >
						-1)
			)
		},

		isCustomsPlantioSelected(feature) {
			return (
				!this.filtroConfig.customsPlantio.length ||
				(this.filtroConfig.customsPlantio.length &&
					this.filtroConfig.customsPlantio.some((a, b, c) => {
						c = feature.properties.customsPlantio.map((e) => e.Value)
						return c.indexOf(a) > -1
					}))
			)
		},

		isCustomsTalhaoSelected(feature) {
			return (
				!this.filtroConfig.customsTalhao.length ||
				(this.filtroConfig.customsTalhao.length &&
					this.filtroConfig.customsTalhao.some((a, b, c) => {
						c = feature.properties.customsTalhao.map((e) => e.Value)
						return c.indexOf(a) > -1
					}))
			)
		},

		selecionaPorCodigo(e) {
			this.filtroConfig.codigosColados = e
				.split(';')
				.map((i) => i.trim())
				.filter((f) => f.length != 0).length
				? e.split(';').map((i) => i.trim())
				: []
		},
		selecionaPorCodigoTalhao(e) {
			this.filtroConfig.codigosColadosTalhao = e
				.split(';')
				.map((i) => i.trim())
				.filter((f) => f.length != 0).length
				? e.split(';').map((i) => i.trim())
				: []
		},
		mark(event) {
			if (!event.properties.blocked) event.properties.selected = !event.properties.selected
		},
		async idFazenda() {
			this.buscandoFazenda = true
			getMaps({
				FazendasIds: [this.model.fk_fzda_fazenda],
				IsContinuo: !this.model.esfl_is_traditional,
			}).then(({ data }) => {
				this.model.fazenda = this.fazendas.find((f) => f.id === this.model.fk_fzda_fazenda)?.Nome
				const { fazenda, talhoes, plantios } = data.result.maps[0]

				this.setAllShapes({
					fazenda: JSON.parse(fazenda),
					talhoes: JSON.parse(talhoes),
					plantios: JSON.parse(plantios),
				})

				this.filtros = data.result.filtros
				this.buscandoFazenda = false
			})
		},
	},
	computed: {
		...mapGetters('moduleImportShape', [
			'areaEstrato',
			'getGeoJsonFzda',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
			'isGeoJsonPlantioEmpty',
		]),
		preparaPlanejamento() {
			return Object.entries(this.getGeoJsonPtio).length
				? this.getGeoJsonPtio.features
						.filter((feature) => feature.properties.selected)
						.map((feature) => {
							return {
								fk_fzda_fazenda: feature.properties.fkFazenda,
								fk_esfl_estrato_florestal: this.model.id,
								plaes_is_traditional: this.model.esfl_is_traditional,
								fk_tlho_talhao: feature.properties.fkTalhao,
								fk_ptio_plantio: feature.properties.idPlantio,
							}
						})
				: []
		},

		minArea() {
			return this.filtros.areaEfetivaPlantioMaxMin?.item1 || 0
		},
		minAreaTalhao() {
			return this.filtros.areaEfetivaTalhaoMaxMin?.item1 || 0
		},

		maxArea() {
			return this.filtros.areaEfetivaPlantioMaxMin?.item2 || 10
		},
		maxAreaTalhao() {
			return this.filtros.areaEfetivaTalhaoMaxMin?.item2 || 10
		},

		rootStyle() {
			return {
				['--color-green']: getComputedStyle(document.documentElement)
					.getPropertyValue('--color-green')
					.trim(),
				['--color-success-background']: getComputedStyle(document.documentElement)
					.getPropertyValue('--color-success-background')
					.trim(),
			}
		},

		maxTimestamp() {
			return new Date(this.filtros.dataPlantioMaxMin?.item2).getTime() + 47304000000 || 100
		},
		minTimestamp() {
			return new Date(this.filtros.dataPlantioMaxMin?.item1).getTime() || 0
		},
		espacamentoPlantio() {
			return Object.entries(this.filtros).length === 0
				? []
				: this.filtros.espacamentoPlantio.map((m) => {
						return {
							label: m.item1,
							value: m.item1,
							blocked: m.item2,
						}
					})
		},

		dataPlantio() {
			return Object.entries(this.filtros).length === 0
				? []
				: this.filtros.dataPlantio.map((m) => {
						const data = new Date(m.item1)
						return {
							label: `${data.toLocaleDateString()} - ${(
								(new Date() - data) /
								(1000 * 3600 * 24) /
								365.5
							).toFixed(2)} anos`,
							value: m.item1,
							blocked: m.item2,
						}
					})
		},

		idadePlantio() {
			return Object.entries(this.filtros).length == 0
				? []
				: this.filtros.dataPlantio.map((m) => {
						return {
							label: ((new Date() - new Date(m)) / (1000 * 3600 * 24) / 365.5).toFixed(2),
							value: m,
						}
					})
		},

		areaTalhao() {
			return Object.entries(this.filtros).length == 0
				? []
				: this.filtros.areaEfetivaTalhao.map((m) => {
						return {
							label: m.item1,
							value: m.item1,
							blocked: m.item2,
						}
					})
		},
		areaPlantio() {
			return Object.entries(this.filtros).length == 0
				? []
				: this.filtros.areaEfetivaPlantio.map((m) => {
						return {
							label: m.item1,
							value: m.item1,
							blocked: m.item2,
						}
					})
		},

		materialPlantio() {
			return Object.entries(this.filtros).length == 0
				? []
				: this.filtros.materialGenetico.map((m) => {
						return {
							label: m.item1,
							value: m.item1,
							blocked: m.item2,
						}
					})
		},

		codPlantio() {
			return Object.entries(this.filtros).length == 0
				? []
				: this.filtros.codigoPlantio.map((m) => {
						return {
							label: m.item2,
							value: m.item1,
							blocked: m.item3,
						}
					})
		},
		codTalhao() {
			return Object.entries(this.filtros).length == 0
				? []
				: this.filtros.codigoTalhao.map((m) => {
						return {
							label: m.item2,
							value: m.item1,
							blocked: m.item3,
						}
					})
		},
	},
	watch: {
		filtroConfig: {
			handler() {
				this.setPlantioSelected()
			},
			deep: true,
		},
	},
}

export default mixins
